// extracted by mini-css-extract-plugin
export default {"container":"FilterMenu-module__container___scFnY","list":"FilterMenu-module__list___AxQ5L"};